// extracted by mini-css-extract-plugin
export default {"body":"body-bJhYj","radio":"radio-xGCSb","description":"description-u9KuW"};